import { IonText } from "@ionic/react";
import { useState } from "react";

const Expandable:React.FC = ({children, ...props}) =>{
  const [expanded, setExpanded] = useState(false);

  return <>
    <IonText className="clickable" color="secondary" onClick={()=>{setExpanded(!expanded)}}>
      <span>{!expanded? <>... [Click to expand.]</> : <>[Click to collapse.]</>}</span>
    </IonText>
    {expanded? children : <></>}
  </>
};

export default Expandable